import script from "./room.vue?vue&type=script&setup=true&lang=js"
export * from "./room.vue?vue&type=script&setup=true&lang=js"

import "./room.vue?vue&type=style&index=0&id=14b7caf6&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b7caf6"]])

export default __exports__